import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig?._retry && !orig?.url?.includes("/auth/")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        // refresh failed — fall through to the 401
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e: any): string => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something glitched. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x: any) => x?.msg || "").filter(Boolean).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
};

export default api;
